import React from "react"
import { CircularProgress } from '@mui/material';
import {
    LineChart,
    XAxis,
    YAxis,
    Tooltip,
    Line
} from "recharts";
import moment from "moment";
import { Typography } from "@mui/material";

export default function Root() {
    const [data, setData] = React.useState([]);

    React.useEffect(() =>
        fetch("https://6r8qwovbu7.execute-api.us-east-2.amazonaws.com/default/scan_num_covid_repos")
            .then(response => response.json())
            .then(data => setData(
                data.body.map(datum => ({
                    numRepos: datum.num_repos,
                    date: new Date(datum.date)
                }))
            )), [])

    return <div style={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }}>
        {data.length >= 1
            ? <div style={{
                display: "flex",
                flexDirection: "column"
            }}>
                <Typography variant="h5">
                    COVID Tracker Tracker
                </Typography>
                <Typography variant="subtitle2">
                    <i>
                        Tracks the number of public Github repositories mentioning "COVID Tracker"
                    </i>
                </Typography>
                <LineChart width={1000} height={500} data={data}
                    margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                    <YAxis
                        dataKey="numRepos"
                        ticks={[0, 25, 50, 75, 100, 125, 150]}
                    />
                    <XAxis
                        dataKey="date"
                        tickFormatter={tickItem => moment(tickItem).format('MMM YY')}/>
                    <Line dot={false} dataKey="numRepos" />
                    <Tooltip labelFormatter={(value, name) =>
                        moment(value).format('MMM DD')
                    }
                        formatter={(value, name, props) => [
                            `${value} new repositories`,
                            null
                        ]} />
                </LineChart>
            </div>
            : <CircularProgress />
        }

    </div>
} 